import script from "./TableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TableView.vue?vue&type=script&setup=true&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=cdfeb6de&lang=css"

const __exports__ = script;

export default __exports__